import { FPAddressFormFields } from 'src/hooks/use-address-suggestions';
import { create } from 'zustand';

export const useAddressStateFieldsStore = create<{
  bypassAutocomplete: () => void;
  isAutocompleteEnabled: boolean;
  currentAddressFromAutocomplete: FPAddressFormFields | null;
  setAddressFromAutocomplete: (address: FPAddressFormFields | null) => void;
}>((set) => ({
  bypassAutocomplete: () => set(() => ({ isAutocompleteEnabled: false })),
  isAutocompleteEnabled: true,
  currentAddressFromAutocomplete: null,
  setAddressFromAutocomplete: (address: FPAddressFormFields | null) =>
    set(() => ({ currentAddressFromAutocomplete: address })),
}));
